export default __webpack_public_path__ + "static/astm_logo.inline-680c302f9e0122bd4b98d77992d22c6b.png";